/**
 * Xero invoice "Dates" and "Linking" fieldsets extracted from XeroManualForm
 * to keep the parent component under the max-lines ceiling.
 */

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { DateField, UuidField } from './xero-form-dates-linking/xero-form-dates-linking.parts'

interface XeroFormDatesLinkingProps {
  formData: {
    invoiceDate: string
    dueDate: string
    fullyPaidOn: string
    entitlementId: string
    purchaseRequestId: string
  }
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
}

export function XeroFormDatesLinking({
  formData,
  onChange,
}: XeroFormDatesLinkingProps): ReactElement {
  const { t } = useTranslation('admin')
  const placeholder = t('licensing.xero.uuidPlaceholder')
  return (
    <>
      <fieldset className="space-y-4">
        <legend className="text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('licensing.xero.dates')}
        </legend>
        <div className="grid gap-4 sm:grid-cols-3">
          <DateField
            id="invoiceDate"
            name="invoiceDate"
            value={formData.invoiceDate}
            label={t('licensing.xero.invoiceDate')}
            onChange={onChange}
          />
          <DateField
            id="dueDate"
            name="dueDate"
            value={formData.dueDate}
            label={t('licensing.xero.dueDate')}
            onChange={onChange}
          />
          <DateField
            id="fullyPaidOn"
            name="fullyPaidOn"
            value={formData.fullyPaidOn}
            label={t('licensing.xero.fullyPaidOn')}
            onChange={onChange}
          />
        </div>
      </fieldset>
      <fieldset className="space-y-4">
        <legend className="text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('licensing.xero.linkingOptional')}
        </legend>
        <div className="grid gap-4 sm:grid-cols-2">
          <UuidField
            id="entitlementId"
            name="entitlementId"
            value={formData.entitlementId}
            label={t('licensing.xero.entitlementId')}
            placeholder={placeholder}
            onChange={onChange}
          />
          <UuidField
            id="purchaseRequestId"
            name="purchaseRequestId"
            value={formData.purchaseRequestId}
            label={t('licensing.xero.purchaseRequestId')}
            placeholder={placeholder}
            onChange={onChange}
          />
        </div>
      </fieldset>
    </>
  )
}
